import { Fetcher } from '../../Fetcher';

import type { IHistoryGame, IOlderHistoryData, ISingleHistory, ISingleHistoryData, ITodayHistoryData } from './types';

export interface FetchTodayHistoryParams {
  env: string;
  userId: string;
  JSESSIONID: string;
}

const mapGameWithDate = (game: IHistoryGame, day: string): IHistoryGame => {
  if (!game.day) {
    game.day = day;
  }
  return game;
};

export const fetchTodayHistory = ({ env, userId, JSESSIONID }: FetchTodayHistoryParams): Promise<IHistoryGame[]> => {
  return Fetcher.fetch<ITodayHistoryData>(env + '/cgibin/usermanagement/audit/day.jsp', {
    params: {
      user_id: userId,
      JSESSIONID,
      format: 'xml',
    },
    ttl: 10_000, // 10 sek
    format: 'xml',
    root: 'days',
  }).then((data: ITodayHistoryData) =>
    data.day.games
      ? data.day.games.game instanceof Array
        ? data.day.games?.game.map((game: IHistoryGame) =>
            mapGameWithDate(game, data.day.date ?? new Date().toLocaleDateString('en'))
          )
        : [mapGameWithDate(data.day.games?.game, data.day.date ?? new Date().toLocaleDateString('en'))]
      : []
  );
};

export interface FetchOlderHistoryParams {
  env: string;
  JSESSIONID: string;
  rowStart: number;
  rowEnd: number;
}

export const fetchOlderHistory = (params: FetchOlderHistoryParams): Promise<IHistoryGame[]> => {
  return Fetcher.fetch<IOlderHistoryData>(params.env + '/api/ui/history/day', {
    params: {
      JSESSIONID: params.JSESSIONID,
      rowStart: params.rowStart,
      rowEnd: params.rowEnd,
    },
    format: 'json',
  }).then((data: IOlderHistoryData) =>
    data.day.flatMap((day) => day.games.game.map((game: IHistoryGame) => mapGameWithDate(game, day.date)))
  );
};

export interface FetchSingleHistoryParams {
  env: string;
  JSESSIONID: string;
  userId: string;
  gameId: number;
}

export const fetchSingleHistory = (params: FetchSingleHistoryParams): Promise<ISingleHistory> => {
  return Fetcher.fetch<ISingleHistoryData>(params.env + '/cgibin/usermanagement/audit/game.jsp', {
    params: {
      user_id: params.userId,
      game_id: params.gameId,
      JSESSIONID: params.JSESSIONID,
      format: 'xml',
    },
    format: 'xml',
  }).then(
    (data: ISingleHistoryData): ISingleHistory => ({
      game: {
        id: Number(data.games.game.gameId),
        name: data.games.game.label,
        cancelled: data.games.game.gameCancelled === 'true',
        simulated: data.games.game.simulationElement,
        date: data.games.game.dataTimeStart,
        netAmount: Number(data.games.game.netAmount),
        roundId: Number(data.games.game.roundId),
        totalBet: Number(data.games.game.stake),
        type: data.games.game.type,

        additional: {
          bingoGameEvents: data.games.game.bingoGameEvents,
          bobDetails: data.games.game.bobDetails,
          kpbGameDetails: data.games.game.kpbGameDetails,
          megaBaccaratGameEvents: data.games.game.megaBaccaratGameEvents,
          rngSlots: data.games.game.rngSlots,
          rouletteDetails: data.games.game.rouletteDetails,
          snlGameDetails: data.games.game.snlGameDetails,
          sweetbonanza: data.games.game.sweetbonanza,
          taGameSummary: data.games.game.taGameSummary,
        },
        tableVariant: data.games.game.tableVariant,
      },
      seats:
        data.games.game.seat instanceof Array
          ? data.games.game.seat
          : data.games.game.seat === undefined
            ? []
            : [data.games.game.seat],
      bets:
        data.games.game.bet instanceof Array
          ? data.games.game.bet
          : data.games.game.bet === undefined
            ? []
            : [data.games.game.bet],
    })
  );
  // .then(() => {
  //
  // });
};
